import React, { useState, useEffect } from "react";
import { Form, Spinner, Dropdown, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { X } from "react-bootstrap-icons";
import { GetPatientDetails } from "features/eliglibility/eligibility-check-list/config/eligibilityCheckListApi";

import { handleClaimFilter } from "../config/claimSlice";

const SearchClaimPatient = ({ resetTrigger, setValue, watch }) => {
  const dispatch = useDispatch();
  const { patientDetails } = useSelector((state) => state.eligibilityCheckList);

  const { claimFilters } = useSelector((state) => state.claim);

  const [searchTerm, setSearchTerm] = useState(claimFilters?.patient);
  const [isLoading, setIsLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const timeoutRef = React.useRef(null);

  useEffect(() => {
    const initialPatient = claimFilters?.patient || "";
    setSearchTerm(initialPatient);
  }, [claimFilters?.patient, setValue, watch]);
  const fetchResults = async (query) => {
    try {
      setIsLoading(true);
      await dispatch(GetPatientDetails({ patient_det: query })).unwrap();
      setShowDropdown(true);
    } catch (error) {
      console.error("Search failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClearInput = () => {
    setSearchTerm("");
    dispatch(handleClaimFilter({ check: "patient", value: "" }));
    setShowDropdown(false);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    dispatch(handleClaimFilter({ check: "patient", value }));
  };

  useEffect(() => {
    if (searchTerm.trim()) {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        fetchResults(searchTerm);
      }, 300);
    } else {
      setShowDropdown(false);
    }

    return () => clearTimeout(timeoutRef.current);
  }, [searchTerm]);

  // useEffect(() => {
  //   handleClearInput();
  // }, [resetTrigger]);

  return (
    <Col xs={12} sm={6} md={4} xl={3} className="position-relative">
      <Form.Group controlId="searchField">
        <Form.Label>Patient</Form.Label>
        <div className="position-relative">
          <Form.Control
            type="text"
            placeholder="Search..."
            value={searchTerm}
            size="sm"
            onChange={handleSearchChange}
            className="pe-4 w-100"
          />

          {searchTerm && !isLoading && (
            <div className="position-absolute end-0 top-50 translate-middle-y me-2">
              <button
                type="button"
                className="btn btn-link p-0 border-0"
                onClick={handleClearInput}
                aria-label="Clear search"
              >
                <X className="text-secondary" />
              </button>
            </div>
          )}

          {isLoading && (
            <div className="position-absolute end-0 top-50 translate-middle-y me-2">
              <Spinner
                animation="border"
                role="status"
                size="sm"
                className="text-secondary"
              >
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          )}
        </div>
        <Dropdown show={showDropdown && patientDetails.length > 0}>
          <Dropdown.Menu
            className="w-100 mt-1"
            style={{ maxHeight: "300px", overflowY: "auto" }}
          >
            {patientDetails.map((result) => (
              <Dropdown.Item
                key={result}
                onClick={() => {
                  // Update both Redux and form state
                  dispatch(
                    handleClaimFilter({
                      check: "patient",
                      value: result,
                    })
                  );
                  setValue("patient", result);
                  setShowDropdown(false);
                }}
              >
                {result}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </Form.Group>
    </Col>
  );
};

export default SearchClaimPatient;
